module.exports = __webpack_public_path__ + "assets/img/root_sm-aac5c740a2adfbedc075a8f9eade0d47.png";


//////////////////
// WEBPACK FOOTER
// ./theroot/root-100-2019/src/img/root_sm.png
// module id = 215
// module chunks = 0